import Link from "next/link";

import { Image } from "shared/components/atoms/Image";
import { Topic } from "shared/types";
import { getFormatTopicDate } from "features/media/utils/getFormatTopicDate";
import { useTopicImage } from "features/media/hooks/useTopicImage";

const ColumnListItem = ({ topic }: { topic: Topic }) => {
  const { smallImage } = useTopicImage(topic);
  const { lastmod } = getFormatTopicDate(topic);
  return (
    <li>
      <Link
        key={topic.id}
        href={`/${topic.mediaType}/column/${topic.id}`}
        passHref
        prefetch={false}
      >
        <a tw="flex border-b border-solid border-gray py-3 px-4 cursor-pointer">
          <Image
            src={smallImage}
            width={64}
            height={64}
            layout="fixed"
            alt={topic.title}
            tw="rounded mr-2"
          />
          <div tw="flex flex-col justify-between">
            <h3 tw="font-normal text-xs tracking-[.35px] leading-5 line-clamp-2">
              {topic.title}
            </h3>
            <time tw="font-normal text-2xs text-secondary tracking-[-0.3px] leading-[10px]">
              {lastmod}
            </time>
          </div>
        </a>
      </Link>
    </li>
  );
};

interface Props {
  topics: Topic[];
}

export const ColumnList = ({ topics }: Props) => {
  return (
    <ul tw="border-t border-solid border-gray">
      {topics.map((topic: Topic) => (
        <ColumnListItem key={topic.id} topic={topic} />
      ))}
    </ul>
  );
};
